import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { salesCalculateReport, calculateReportExlUpload } from 'lib/api/sales';
import { showSuccessSnackbar } from 'modules/snackbar';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { setPortal } from 'modules/portal';
import MbUpload from 'components/organisms/MbUpload';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewButton from 'components/molecules/NewButton';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';
import { useDispatch, useSelector } from 'react-redux';
import numeral from 'numeral';

const StatisticsEtc = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const initList = {
    adutSvcDtlTpCode: [
      { label: '전체', value: 'all' },
      { label: '애드익스', value: '01' },
      { label: '통대행', value: '02' },
      { label: '애드서버', value: '03' },
      { label: '모비믹서', value: '04' },
    ],
    mobonFlag: [
      { label: '제외', value: 'all' },
      { label: '포함', value: '01' },
    ],
  };

  let initParams = {
    adutSvcTpCode: '03',
    adutSvcDtlTpCode: 'all',
    sMth: moment().add(-12, 'month').format('YYYYMM'),
    eMth: moment().format('YYYYMM'),
    mobonFlag: 'all',
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [reFetchHead, setReFetchHead] = useState(false);
  const [reFetch, setReFetch] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  useEffect(() => {
    if (reFetchHead === true) {
      setReFetchHead(false);
    } // eslint-disable-next-line
  }, [reFetchHead]);

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const customized = {
    default: {
      TOT_CF_AMT: {
        makeHead: () => {
          return t('총 확정매출');
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'TOT_CF_AMT');
          return (
            <>{makeRowColumn(rowObj['TOT_CF_AMT'], obj.type, obj.format)}</>
          );
        },
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
        },
      },
      SALES_BILL_VAT_SEP: {
        makeHead: (headsMap) => {
          const result = { content: '', orderFlag: true };
          result.content = (
            <SpanningTableContents
              topTitle={t('계산서 금액(매출)')}
              type="head"
            >
              <div style={{ width: 100 }}>{t('VAT별도')}</div>
              <div style={{ width: 100 }}>{t('VAT포함')}</div>
            </SpanningTableContents>
          );
          return result;
        },
        makeBody: (rowObj, headsMap) => {
          return (
            <SpanningTableContents>
              <div style={{ width: 100 }}>
                {numeral(rowObj['SALES_BILL_VAT_SEP']).format('#,##0')}
              </div>
              <div style={{ width: 100 }}>
                {numeral(rowObj['SALES_BILL_VAT_INC']).format('#,##0')}
              </div>
            </SpanningTableContents>
          );
        },
        orderFlag: false,
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
      },
      SALES_BILL_VAT_INC: {
        merged: true,
      },

      DEPOSIT_AMT: {
        makeHead: () => {
          return t('실제입금액');
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'DEPOSIT_AMT');
          return (
            <>{makeRowColumn(rowObj['DEPOSIT_AMT'], obj.type, obj.format)}</>
          );
        },
        headStyle: {
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderRight: '1px solid #e5e8eb',
        },
      },
      ADUT_SVC_DTL_TP_CODE: {
        merged: true,
      },
      MANAGE_ICONS: {
        headStyle: {
          width: 80,
        },
      },
    },
    sub: {
      ORDER_AMT_KR: {
        makeHead: () => {
          const result = { content: '', orderFlag: true };
          result.content = (
            <SpanningTableContents topTitle={t('원화')} type="head">
              <div style={{ width: 100 }}>{t('매출(KRW)')}</div>
            </SpanningTableContents>
          );
          return result;
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'ORDER_AMT_KR');
          return (
            <>{makeRowColumn(rowObj['ORDER_AMT_KR'], obj.type, obj.format)}</>
          );
        },
        orderFlag: false,
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
        },
      },
      ORDER_AMT_US: {
        makeHead: () => {
          const result = { content: '', orderFlag: true };
          result.content = (
            <SpanningTableContents topTitle={t('외화')} type="head">
              <div style={{ width: 100 }}>{t('매출(USD)')}</div>
              <div style={{ width: 100 }}>{t('마감금액')}</div>
            </SpanningTableContents>
          );
          return result;
        },
        makeBody: (rowObj) => {
          return (
            <SpanningTableContents>
              <div style={{ width: 100 }}>
                {numeral(rowObj['ORDER_AMT_US']).format('#,##0')}
              </div>
              <div style={{ width: 100 }}>
                {numeral(rowObj['DL_ORDER_AMT_US']).format('#,##0')}
              </div>
            </SpanningTableContents>
          );
        },
        orderFlag: false,
        headStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderLeft: '1px solid #e5e8eb',
          borderRight: '1px solid #e5e8eb',
        },
      },
      DL_ORDER_AMT_US: {
        merged: true,
      },
      ACC_ORDER_AMT: {
        makeHead: () => {
          return (
            <span>
              {t('회계매출')}
              <br />
              {t('(원화+외화마감금액)')}
            </span>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'ACC_ORDER_AMT');
          return (
            <>{makeRowColumn(rowObj['ACC_ORDER_AMT'], obj.type, obj.format)}</>
          );
        },
      },
      INTRCP_RSN_AMT: {
        makeHead: () => {
          return (
            <span>
              {t('비고액')}
              <br />
              {t('(+/-)')}
            </span>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'INTRCP_RSN_AMT');
          return (
            <>{makeRowColumn(rowObj['INTRCP_RSN_AMT'], obj.type, obj.format)}</>
          );
        },
      },
      CF_AMT: {
        makeHead: () => {
          return (
            <span>
              {t('확정매출')}
              <br />
              {t('(회계매출+비고액)')}
            </span>
          );
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'CF_AMT');
          return <>{makeRowColumn(rowObj['CF_AMT'], obj.type, obj.format)}</>;
        },
        headStyle: {
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderRight: '1px solid #e5e8eb',
        },
      },
      ADUT_SVC_DTL_TP_CODE: {
        merged: true,
      },
      MANAGE_ICONS: {
        headStyle: {
          width: 80,
        },
      },
    },
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(-1, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        let resultData;
        let addParams;

        if (typeof data.ADUT_SVC_DTL_TP_CODE !== 'undefined') {
          addParams =
            '&statsMth=' +
            data['STATS_MTH'] +
            '&adutSvcTpCode=' +
            params.adutSvcTpCode +
            '&adutSvcDtlTpCode=' +
            data['ADUT_SVC_DTL_TP_CODE'];
        } else {
          addParams =
            '&statsMth=' +
            data['STATS_MTH'] +
            '&adutSvcTpCode=' +
            params.adutSvcTpCode;
        }

        if (data.STATS_MTH !== 'total') {
          resultData = (
            <TableBtnWrap>
              <NewButton
                name="mediaPop"
                title={t('연동사별리포트')}
                iconBtn
                icon="faLink"
                onClick={() =>
                  handlePortalUrl('/sales/calculate/exl?isPop=1' + addParams)
                }
                disableRipple
                style={{
                  backgroundColor: '#79bd2f',
                }}
                color="#fff"
              />
              <NewButton
                name="history"
                title={t('히스토리')}
                iconBtn
                icon="faHistory"
                onClick={(e) =>
                  handlePortalUrl(
                    '/sales/calculate/history?isPop=1' + addParams
                  )
                }
                disableRipple
                style={{
                  backgroundColor: '#79bd2f',
                }}
                color="#fff"
              />
            </TableBtnWrap>
          );
        } else {
          resultData = null;
        }
        return resultData;
      },
    });
    return result;
  })();

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    let tempParams = { ...newParams };
    const tableKeys = {
      all: '',
      '01': 'sub',
      '02': 'sub',
      '03': 'sub',
      '04': 'sub',
    };
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      if (
        newParams.adutSvcDtlTpCode !== undefined &&
        newParams.adutSvcDtlTpCode !== 'all'
      ) {
        tempParams = {
          ...tempParams,
          table: tableKeys[newParams.adutSvcDtlTpCode],
        };
      } else if (newParams.adutSvcDtlTpCode === 'all') {
        delete tempParams['table'];
      }

      setReFetchHead(true);
      setParams(tempParams);
    }
  };

  const handleUpload = (status) => {
    setUploading(status);
  };

  const callUpload = async (taskId) => {
    setReFetch(true);
    handleUpload(true);
    await calculateReportExlUpload({ taskId: taskId })
      .then((response) => {
        const { message } = response.data;
        setReFetch(true);
        handleSnackbar({
          message: message,
          option: {
            type: 'success',
          },
        });
      })
      .catch((error) => {
        handleSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        handleUpload(false);
        setReFetch(false);
      });
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useMonthDate
          useDatePresets={false}
        />
        <FilterCollection
          label={t('서비스타입')}
          name="adutSvcDtlTpCode"
          params={params}
          value={params.adutSvcDtlTpCode}
          type="radio"
          list={initList.adutSvcDtlTpCode}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        {params.adutSvcDtlTpCode === '02' && (
          <FilterCollection
            label={t('모비온 소진금액 60%')}
            name="mobonFlag"
            params={params}
            value={params.mobonFlag}
            type="radio"
            list={initList.mobonFlag}
            callBack={getParam}
            labelKey="label"
            valueKey="value"
          />
        )}
        {params.adutSvcDtlTpCode === 'all' && (
          <MbUpload
            name={'upload1'}
            label={t('연동사 세금계산서 업로드')}
            callBack={callUpload}
            uploading={uploading}
          />
        )}
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={salesCalculateReport}
        params={params}
        getParam={getParam}
        title={
          params.adutSvcDtlTpCode === '02'
            ? '*하기 애드센스 회계매출은 전월 매출입니다'
            : ''
        }
        customized={
          params.adutSvcDtlTpCode === 'all'
            ? customized.default
            : customized.sub
        }
        useSearch={false}
        addColumnList={addColumnList}
        reFetch={reFetch}
        useReFetchBtn
        reFetchHead
      />
    </>
  );
};

export default StatisticsEtc;
